import React from "react";
import { HiLockClosed } from "react-icons/hi";
import { ESCALATION_GUARD_MESSAGE } from "./platformRoles.utils";

const PlatformPermissionGrid = ({ sections, onToggle }) => {
  if (!sections.length) {
    return <p className="text-sm text-gray-500">No permissions available.</p>;
  }

  return (
    <div className="space-y-6">
      {sections.map((section) => (
        <section key={section.key}>
          <h3 className="text-sm font-semibold text-gray-900">{section.label}</h3>
          <div className="mt-3 space-y-2 rounded-lg border border-gray-200 p-3">
            {section.permissions.map((permission) => {
              const disabled = !permission.grantable;

              return (
                <label
                  key={permission.id}
                  className={`flex items-start gap-2 text-sm ${
                    disabled ? "text-gray-400" : "text-gray-700"
                  }`}
                  title={disabled ? ESCALATION_GUARD_MESSAGE : undefined}
                >
                  <input
                    type="checkbox"
                    checked={Boolean(permission.checked)}
                    disabled={disabled}
                    onChange={() => onToggle(permission.id)}
                    className="mt-0.5"
                  />
                  <span>
                    <span className="font-medium">{permission.description || permission.name}</span>
                    <span className="mt-0.5 block text-xs text-gray-500">{permission.name}</span>
                    {disabled ? (
                      <span className="mt-1 inline-flex items-center gap-1 text-xs text-amber-700">
                        <HiLockClosed className="h-3 w-3" aria-hidden="true" />
                        Not grantable
                      </span>
                    ) : null}
                  </span>
                </label>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
};

export default PlatformPermissionGrid;
